import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { useRouter } from 'expo-router';
import { TouchableOpacity } from 'react-native';

import { t } from 'state/intl/translations';
import { getDesignToken } from 'styles/constants';
import { routes } from 'utils/routing';

export const HamburgerButton: React.FC<React.PropsWithChildren<{}>> = () => {
  const router = useRouter();

  return (
    <TouchableOpacity
      hitSlop={15}
      testID="hamburger-menu-button"
      onPress={() => router.navigate(routes.account)}
      accessibilityLabel={t('hamburgerMenuAriaLabel')}
      accessibilityRole="button"
    >
      <Icon variant="menu" color={getDesignToken('icon-header-contrast')} aria-hidden size="$6" />
    </TouchableOpacity>
  );
};
